import React from "react";
import {
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { Log, PendingEntityAction } from "../../../services/services";
import FormDialog from "../../FormDialog";

const RejectPendingEntity = ({
  open,
  onClose,
  id,
  setEntityList,
  setLoaded,
}) => {
  const {
    handleChange,
    handleSubmit,
    handleBlur,
    values,
    touched,
    errors,
    isSubmitting,
    resetForm,
  } = useFormik({
    initialValues: {
      reason: "",
    },
    validationSchema: yup.object().shape({
      reason: yup.string().required("Required").trim(),
    }),
    onSubmit: async (values) => {
      Log.info(`Click button [Reject] - Reject Business Entity by Id: ${id}`, values)
      await PendingEntityAction(id, "reject", setEntityList, setLoaded, { reject_message: values.reason });
      handleClose(true);
    }
  });

  const handleClose = (isSubmitted) => {
    onClose(isSubmitted);
    resetForm();
  };

  return (
      <FormDialog
        open={open}
        onClose={handleClose}
        title="Reject this entity?"
        handleSubmit={handleSubmit}
        loading={isSubmitting}
        maxWidth="sm"
      >
        <Grid container sx={{ alignItems: "center" }} spacing={3}>
          <Grid item md={5} xs={5}>
            <Typography variant="subtitle1">Reason *</Typography>
          </Grid>
          <Grid item md={7} xs={7}>
            <TextField
              name="reason"
              value={values.reason}
              onChange={handleChange}
              onBlur={handleBlur}
              variant="outlined"
              fullWidth
              size="small"
              multiline
              rows={2}
              placeholder="Please enter your reason"
              error={Boolean(touched.reason && errors.reason)}
              helperText={touched.reason && errors.reason}
              disabled={isSubmitting}
            />
          </Grid>
        </Grid>
      </FormDialog>
  );
};

export default RejectPendingEntity;
